<template>
    <Transition name="fade">
        <CRow class="d-flex justify-content-center mb-2" v-if="isActive">
            <CCol col="12" lg="10" xl="7">
                <CCard style="border-color: #39f;">
                    <CCardBody>
                        <div class="text-justify" v-html="content"></div>
                        <div class="text-right">
                            <CButton size="sm" color="info" @click="hide()">Hide</CButton>
                        </div>
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
    </Transition>
</template>

<script>
import { store } from '@/scripts/globals'

const STORAGE_KEY = 'hide_announcement_hash';

export default {
    data() {
        return {
            store,
            shouldHide: false,
        }
    },
    computed: {
        announcement() {
            return store.myUser?.announcement
        },
        isActive() {
            return Boolean(this.announcement?.text) && !this.shouldHide
        },
        content() {
            return String(this.announcement?.text)
        },
        hash() {
            return String(this.announcement?.hash)
        }
    },
    methods: {
        hide() {
            this.setStoredHash(this.hash);
            this.shouldHide = true;
        },
        getStoredHash() {
            return window.localStorage.getItem(STORAGE_KEY) ?? '';
        },
        setStoredHash(hash) {
            window.localStorage.setItem(STORAGE_KEY, hash);
        }
    },
    created() {
        if (this.hash === this.getStoredHash()) {
            this.shouldHide = true;
        }
    }
}
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>